<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-ticket"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'indicacoes.cupons.titulo_pagina' | translate }}</h1>
    <p class="header-subtitle">{{ 'indicacoes.cupons.subtitulo_pagina' | translate }}</p>
  </div>
</div>

<div class="page-body">
<div class="table-card">
  <div class="card-header">
    <div class="card-header-icon table-icon">
      <i class="pi" [ngClass]="resultadoMaster ? 'pi-building' : 'pi-ticket'"></i>
    </div>

    <span class="card-header-title" *ngIf="!resultadoMaster">
      {{ 'indicacoes.cupons.titulo' | translate }}
    </span>
    <span class="card-header-title" *ngIf="resultadoMaster">
      {{ 'indicacoes.consulta_master.titulo_card' | translate }} — {{ resultadoMaster.nomeEmpresa }}
    </span>

    <!-- Drill-in ativo: voltar para a lista de cupons -->
    <button *ngIf="resultadoMaster"
      pButton
      [label]="'indicacoes.consulta_master.limpar' | translate"
      icon="pi pi-arrow-left"
      class="p-button-text btn-sm btn-voltar-meus"
      (click)="limparConsultaMaster()">
    </button>

    <!-- Busca da lista de cupons + criar novo cupom -->
    <div class="card-header-actions" *ngIf="!resultadoMaster">
      <span class="p-input-icon-left master-busca-lista">
        <i class="pi pi-search"></i>
        <input type="text" pInputText
          [(ngModel)]="cuponsBusca"
          (ngModelChange)="onBuscaCuponsChange()"
          [placeholder]="'indicacoes.cupons.buscar_placeholder' | translate"
          autocomplete="off" />
      </span>
      <button pButton
        [label]="'indicacoes.percentual_padrao.botao' | translate"
        icon="pi pi-percentage"
        class="p-button-outlined btn-sm"
        [pTooltip]="'indicacoes.percentual_padrao.botao_ajuda' | translate"
        tooltipPosition="bottom"
        (click)="abrirPercentualPadrao()">
      </button>
      <button pButton
        [label]="'indicacoes.novo_cupom.botao' | translate"
        icon="pi pi-plus"
        class="btn-primary btn-sm"
        (click)="abrirNovoCupom()">
      </button>
    </div>
  </div>

  <div class="card-content">

    <!-- Sem consulta drill-in ativa: lista TODOS os cupons paginado -->
    <ng-container *ngIf="!resultadoMaster">
      <!-- Loading de um drill-in em andamento (clique em "Ver detalhe") -->
      <div *ngIf="carregandoMaster" class="estado-inline">
        <i class="pi pi-spinner pi-spin"></i>
      </div>

      <ng-container *ngIf="!carregandoMaster">
        <!-- Barra de lote: so aparece com algum cupom marcado -->
        <div class="lote-bar" *ngIf="cuponsSelecionados.length > 0">
          <span class="lote-bar-info">
            {{ 'indicacoes.revogar_cupons.selecionados' | translate: { count: cuponsSelecionados.length } }}
          </span>
          <button pButton
            type="button"
            icon="pi pi-ban"
            class="p-button-danger btn-sm"
            style="gap: 0.35rem"
            [label]="'indicacoes.revogar_cupons.botao' | translate: { count: cuponsSelecionados.length }"
            [disabled]="revogandoCupons"
            (click)="abrirRevogarCupons()">
          </button>
        </div>

        <p-table [value]="cupons"
          [loading]="carregandoCupons"
          [customSort]="true"
          (onSort)="onSortCupons($event)"
          dataKey="cupomId"
          selectionMode="multiple"
          [metaKeySelection]="false"
          [rowSelectable]="isCupomSelecionavel"
          [selection]="cuponsSelecionados"
          (selectionChange)="cuponsSelecionados = $event"
          [tableStyle]="{ width: '100%' }">

          <ng-template pTemplate="header">
            <tr>
              <th class="col-selecao" style="width: 3.5rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              </th>
              <th style="width: 10%" pSortableColumn="codigo">
                {{ 'indicacoes.cupons.codigo' | translate }}<p-sortIcon [field]="'codigo'"></p-sortIcon>
              </th>
              <!-- Tipo do cupom: so o cupom ESPECIAL ganha marca (um icone), porque e a
                   excecao — o comum de indicacao e o caso normal e nao precisa de selo. -->
              <th style="width: 5%" class="text-center">{{ 'indicacoes.cupons.tipo' | translate }}</th>
              <th style="width: 16%">{{ 'indicacoes.cupons.empresa' | translate }}</th>
              <th style="width: 9%" pSortableColumn="porcentagemDesconto">
                {{ 'indicacoes.cupom_detalhe.desconto' | translate }}<p-sortIcon [field]="'porcentagemDesconto'"></p-sortIcon>
              </th>
              <th style="width: 9%" pSortableColumn="porcentagemComissao">
                {{ 'indicacoes.cupom_detalhe.comissao' | translate }}<p-sortIcon [field]="'porcentagemComissao'"></p-sortIcon>
              </th>
              <th style="width: 10%">{{ 'indicacoes.cupons.validade' | translate }}</th>
              <th style="width: 8%">{{ 'indicacoes.cupons.indicacoes' | translate }}</th>
              <th style="width: 9%">{{ 'indicacoes.cupons.confirmadas' | translate }}</th>
              <th style="width: 12%">{{ 'indicacoes.cupons.comissao' | translate }}</th>
              <th style="width: 12%">{{ 'indicacoes.tabela.acoes' | translate }}</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-cupom let-rowIndex="rowIndex">
            <tr [pSelectableRow]="cupom"
                [pSelectableRowIndex]="rowIndex"
                [class.linha-selecionavel]="cupomRevogavel(cupom)">
              <!-- stopPropagation: sem isso o clique no checkbox alterna a selecao pelo
                   p-tableCheckbox E borbulha ate o pSelectableRow, anulando a marcacao. -->
              <td class="col-selecao" (click)="$event.stopPropagation()">
                <p-tableCheckbox
                  [value]="cupom"
                  [disabled]="!cupomRevogavel(cupom)">
                </p-tableCheckbox>
              </td>
              <td><span class="codigo-valor">{{ cupom.codigoIndicacao }}</span></td>
              <td class="text-center">
                <i *ngIf="cupom.especial"
                   class="pi pi-star-fill cupom-especial-icone"
                   [pTooltip]="tooltipCupomEspecial(cupom)"
                   tooltipPosition="top"
                   [attr.aria-label]="tooltipCupomEspecial(cupom)"></i>
              </td>
              <td>
                <span *ngIf="cupom.empresaId != null">{{ cupom.nomeEmpresa }}</span>
                <span *ngIf="cupom.empresaId == null" class="cupom-promocional">
                  {{ 'indicacoes.cupons.promocional' | translate }}
                </span>
              </td>
              <!-- No cupom especial nao ha percentual: a coluna passa a mostrar o valor
                   negociado — ou "Sem cobranca", quando o plano e cortesia. -->
              <td>
                <span *ngIf="!cupom.especial">{{ cupom.porcentagemDesconto }}%</span>
                <span *ngIf="cupom.especial && !cupom.semCobranca">{{ (cupom.valorPlano ?? null) | guaraniFormat }}</span>
                <span *ngIf="cupom.especial && cupom.semCobranca" class="cupom-promocional">
                  {{ 'indicacoes.cupons.sem_cobranca' | translate }}
                </span>
              </td>
              <td>{{ cupom.porcentagemComissao }}%</td>
              <td>
                <span *ngIf="!cupomSemValidade(cupom.dataValidade)">{{ labelValidadeCupom(cupom.dataValidade) }}</span>
                <span *ngIf="cupomSemValidade(cupom.dataValidade)" class="cupom-promocional">
                  {{ 'indicacoes.cupom_detalhe.sem_expiracao' | translate }}
                </span>
              </td>
              <td>{{ cupom.totalIndicacoes }}</td>
              <td>{{ cupom.totalConfirmadas }}</td>
              <td>{{ cupom.comissaoAcumuladaTotal | guaraniFormat }}</td>
              <td class="actions">
                <button
                  pButton
                  icon="pi pi-eye"
                  [label]="'indicacoes.tabela.ver_detalhe' | translate"
                  class="p-button-text p-button-sm"
                  (click)="abrirCupom(cupom)">
                </button>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="11" class="text-center p-5">
                <div class="flex flex-column align-items-center">
                  <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                  <div class="text-gray-500 text-lg">{{ 'indicacoes.cupons.vazio' | translate }}</div>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="loadingbody">
            <tr>
              <td colspan="11" class="text-center p-5">
                <div class="flex justify-content-center align-items-center">
                  <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                  <span class="ml-3">{{ 'indicacoes.tabela.carregando' | translate }}</span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!-- Paginacao server-side dos cupons (mesmo padrao da Lista de Produtos) -->
        <div class="pagination-container">
          <div>
            <p-paginator
              (onPageChange)="onPageChangeCupons($any($event))"
              [showCurrentPageReport]="true"
              [currentPageReportTemplate]="'indicacoes.tabela.contagem' | translate"
              [first]="firstCupons" [rows]="rowsCupons"
              [totalRecords]="totalCupons" [showFirstLastIcon]="true">
            </p-paginator>
          </div>
          <div class="flex align-items-center">
            <span class="mx-1 text-color">{{ 'indicacoes.tabela.itens_por_pagina' | translate }}</span>
            <p-dropdown [options]="pageSizeOptions" optionLabel="label"
              optionValue="value" [(ngModel)]="rowsCupons"
              (ngModelChange)="onRowsPerPageChangeCupons()" styleClass="w-6rem"
              appendTo="body">
            </p-dropdown>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- Resultado da empresa consultada -->
    <ng-container *ngIf="resultadoMaster">
      <!-- Seletor "Geral x cupom" da empresa consultada (consulta_escopo_cupom / FE-2) -->
      <div class="seletor-cupom-row" *ngIf="escopoMasterOptions.length > 1">
        <label class="seletor-cupom-label" for="seletorCupomMaster">
          {{ 'indicacoes.seletor.label' | translate }}
        </label>
        <p-dropdown
          inputId="seletorCupomMaster"
          [options]="escopoMasterOptions"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="cupomMasterSelecionadoId"
          (onChange)="onEscopoMasterChange()"
          [disabled]="carregandoMaster"
          styleClass="seletor-cupom-dropdown"
          [attr.aria-label]="'indicacoes.seletor.label' | translate">
        </p-dropdown>
      </div>

      <!-- Codigo + link da empresa consultada -->
      <div class="master-link" *ngIf="temCodigoMaster">
        <div class="codigo-row">
          <span class="codigo-label">{{ 'indicacoes.codigo' | translate }}:</span>
          <span class="codigo-valor">{{ resultadoMaster.codigoIndicacao }}</span>

          <!-- Parametros do cupom da empresa consultada -->
          <span class="cupom-detalhes"
            *ngIf="resultadoMaster.porcentagemDesconto != null || resultadoMaster.porcentagemComissao != null || resultadoMaster.tipoPeriodo">
            <!-- Cupom ESPECIAL: em vez do percentual (que nele e sempre 0 e nao diz nada),
                 mostra o plano que ele define — faixa, valor, prazo e limite de vendas. -->
            <ng-container *ngIf="resultadoMaster.especial">
              <span class="cupom-detalhe cupom-detalhe--especial">
                <i class="pi pi-star-fill cupom-especial-icone" aria-hidden="true"></i>
                <span class="cupom-detalhe-valor">{{ 'indicacoes.cupons.especial' | translate }}</span>
              </span>
              <span class="cupom-detalhe" *ngIf="resultadoMaster.categoriaPlano">
                <span class="cupom-detalhe-label">{{ 'indicacoes.cupom_detalhe.categoria' | translate }}:</span>
                <span class="cupom-detalhe-valor">{{ rotuloCategoriaPlano(resultadoMaster.categoriaPlano) }}</span>
              </span>
              <span class="cupom-detalhe">
                <span class="cupom-detalhe-label">{{ 'indicacoes.cupom_detalhe.valor_plano' | translate }}:</span>
                <span class="cupom-detalhe-valor" *ngIf="!resultadoMaster.semCobranca">{{ (resultadoMaster.valorPlano ?? null) | guaraniFormat }}</span>
                <span class="cupom-detalhe-valor" *ngIf="resultadoMaster.semCobranca">{{ 'indicacoes.cupons.sem_cobranca' | translate }}</span>
              </span>
              <span class="cupom-detalhe" *ngIf="resultadoMaster.periodoDias">
                <span class="cupom-detalhe-label">{{ 'indicacoes.cupom_detalhe.periodo_plano' | translate }}:</span>
                <span class="cupom-detalhe-valor">{{ 'indicacoes.cupons.periodo_dias' | translate:{ dias: resultadoMaster.periodoDias } }}</span>
              </span>
              <span class="cupom-detalhe" *ngIf="resultadoMaster.limiteDeGasto != null">
                <span class="cupom-detalhe-label">{{ 'indicacoes.cupom_detalhe.limite_vendas' | translate }}:</span>
                <span class="cupom-detalhe-valor">{{ resultadoMaster.limiteDeGasto | guaraniFormat }}</span>
              </span>
            </ng-container>
            <span class="cupom-detalhe" *ngIf="!resultadoMaster.especial && resultadoMaster.porcentagemDesconto != null">
              <span class="cupom-detalhe-label">{{ 'indicacoes.cupom_detalhe.desconto' | translate }}:</span>
              <span class="cupom-detalhe-valor">{{ resultadoMaster.porcentagemDesconto }}%</span>
            </span>
            <span class="cupom-detalhe" *ngIf="resultadoMaster.porcentagemComissao != null">
              <span class="cupom-detalhe-label">{{ 'indicacoes.cupom_detalhe.comissao' | translate }}:</span>
              <span class="cupom-detalhe-valor">{{ resultadoMaster.porcentagemComissao }}%</span>
            </span>
            <span class="cupom-detalhe" *ngIf="resultadoMaster.tipoPeriodo">
              <span class="cupom-detalhe-label">{{ 'indicacoes.cupom_detalhe.tipo_periodo' | translate }}:</span>
              <span class="cupom-detalhe-valor">{{ tipoPeriodoLabel(resultadoMaster.tipoPeriodo) }}</span>
            </span>
            <span class="cupom-detalhe" *ngIf="resultadoMaster.dataValidade">
              <span class="cupom-detalhe-label">{{ 'indicacoes.cupom_detalhe.validade' | translate }}:</span>
              <span class="cupom-detalhe-valor" *ngIf="!cupomSemValidade(resultadoMaster.dataValidade)">{{ formatarData(resultadoMaster.dataValidade) }}</span>
              <span class="cupom-detalhe-valor" *ngIf="cupomSemValidade(resultadoMaster.dataValidade)">{{ 'indicacoes.cupom_detalhe.sem_expiracao' | translate }}</span>
              <span class="cupom-vencido-tag" *ngIf="cupomVencido(resultadoMaster.dataValidade)">({{ 'indicacoes.cupom_detalhe.vencido' | translate }})</span>
            </span>
          </span>
        </div>
        <div class="link-row">
          <input type="text" pInputText
            class="link-input"
            [value]="resultadoMaster.linkDeIndicacao"
            readonly
            [attr.aria-label]="'indicacoes.meu_link' | translate" />
        </div>
      </div>

      <div class="master-sem-codigo" *ngIf="!temCodigoMaster">
        <i class="pi pi-info-circle"></i>
        <span>{{ 'indicacoes.consulta_master.sem_codigo' | translate }}</span>
      </div>

      <!-- Resumo de totais da empresa consultada -->
      <div *ngIf="resultadoMaster.resumo" class="resumo-grid">
        <div class="resumo-item">
          <span class="resumo-valor">{{ resultadoMaster.resumo.totalIndicacoes }}</span>
          <span class="resumo-rotulo">{{ 'indicacoes.resumo.total_indicacoes' | translate }}</span>
        </div>
        <div class="resumo-item">
          <span class="resumo-valor">{{ resultadoMaster.resumo.totalConfirmadas }}</span>
          <span class="resumo-rotulo">{{ 'indicacoes.resumo.total_confirmadas' | translate }}</span>
        </div>
        <div class="resumo-item">
          <span class="resumo-valor">{{ resultadoMaster.resumo.comissaoAcumuladaTotal | guaraniFormat }}</span>
          <span class="resumo-rotulo">{{ 'indicacoes.resumo.comissao_acumulada' | translate }}</span>
        </div>
        <div class="resumo-item">
          <span class="resumo-valor">{{ resultadoMaster.resumo.comissaoPendenteTotal | guaraniFormat }}</span>
          <span class="resumo-rotulo">{{ 'indicacoes.resumo.comissao_pendente' | translate }}</span>
        </div>
        <div class="resumo-item">
          <span class="resumo-valor">{{ resultadoMaster.resumo.comissaoPagaTotal | guaraniFormat }}</span>
          <span class="resumo-rotulo">{{ 'indicacoes.resumo.comissao_paga' | translate }}</span>
        </div>
      </div>

      <!-- Tabela de referidos da empresa consultada -->
      <!-- `tabela-espacada-sm`: mesmo respiro da tabela "Minhas indicacoes", para as
           duas abas ficarem consistentes. -->
      <p-table [value]="resultadoMaster.indicacoes.content"
        [loading]="carregandoMaster"
        styleClass="tabela-espacada-sm"
        [tableStyle]="{ width: '100%' }">

        <ng-template pTemplate="header">
          <tr>
            <th style="width: 28%">{{ 'indicacoes.tabela.email_indicado' | translate }}</th>
            <th style="width: 15%">{{ 'indicacoes.tabela.status' | translate }}</th>
            <th style="width: 14%">{{ 'indicacoes.tabela.origem' | translate }}</th>
            <th style="width: 18%">{{ 'indicacoes.tabela.comissao' | translate }}</th>
            <th style="width: 13%">{{ 'indicacoes.tabela.status_repasse' | translate }}</th>
            <th style="width: 12%">{{ 'indicacoes.tabela.acoes' | translate }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-indicacao>
          <tr>
            <td>{{ indicacao.emailIndicado }}</td>
            <td>
              <p-tag
                [value]="labelStatusIndicacao(indicacao.status)"
                [severity]="severityStatusIndicacao(indicacao.status)">
              </p-tag>
            </td>
            <td>
              <span class="origem-cell">
                <i *ngIf="iconeOrigem(indicacao.origem)" [class]="iconeOrigem(indicacao.origem)"></i>
                <span>{{ labelOrigem(indicacao.origem) }}</span>
              </span>
            </td>
            <td>{{ indicacao.comissaoAcumulada | guaraniFormat }}</td>
            <td>
              <p-tag *ngIf="indicacao.statusRepasse"
                [value]="labelStatusRepasseResumo(indicacao.statusRepasse)"
                [severity]="severityStatusRepasse(indicacao.statusRepasse)">
              </p-tag>
              <span *ngIf="!indicacao.statusRepasse">-</span>
            </td>
            <td class="actions">
              <button pButton
                icon="pi pi-eye"
                [label]="'indicacoes.tabela.ver_detalhe' | translate"
                class="p-button-text p-button-sm"
                (click)="abrirDetalheMaster(indicacao)">
              </button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center p-5">
              <div class="flex flex-column align-items-center">
                <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                <div class="text-gray-500 text-lg">{{ 'indicacoes.consulta_master.vazio' | translate }}</div>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="loadingbody">
          <tr>
            <td colspan="6" class="text-center p-5">
              <div class="flex justify-content-center align-items-center">
                <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                <span class="ml-3">{{ 'indicacoes.tabela.carregando' | translate }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Paginacao server-side da consulta master -->
      <div class="pagination-container">
        <p-paginator
          (onPageChange)="onPageChangeMaster($any($event))"
          [showCurrentPageReport]="true"
          [currentPageReportTemplate]="'indicacoes.tabela.contagem' | translate"
          [first]="firstMaster" [rows]="rowsMaster"
          [totalRecords]="totalMaster" [showFirstLastIcon]="true">
        </p-paginator>
      </div>
    </ng-container>

  </div>
</div>
</div>

<!-- =================================================================== -->
<!-- Dialog: Detalhe da indicacao (drill-down)                           -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="detalheDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '44rem' }"
  (onHide)="fecharDetalhe()">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-list" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'indicacoes.detalhe.titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle" *ngIf="indicacaoSelecionada">
          {{ indicacaoSelecionada.emailIndicado }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p class="detalhe-descricao">{{ 'indicacoes.detalhe.descricao' | translate }}</p>

    <!-- Loading -->
    <div *ngIf="carregandoComissoes" class="estado-inline">
      <i class="pi pi-spinner pi-spin" style="font-size: 1.5rem;"></i>
      <span class="ml-2">{{ 'indicacoes.detalhe.carregando' | translate }}</span>
    </div>

    <!-- Empty -->
    <div *ngIf="!carregandoComissoes && comissoes.length === 0" class="estado-vazio">
      <i class="pi pi-inbox text-gray-400" style="font-size: 2.5rem; margin-bottom: 0.75rem;"></i>
      <div class="text-gray-500">{{ 'indicacoes.detalhe.sem_comissoes' | translate }}</div>
    </div>

    <!-- Tabela de competencias -->
    <p-table *ngIf="!carregandoComissoes && comissoes.length > 0"
      [value]="comissoes"
      [tableStyle]="{ width: '100%' }">

      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'indicacoes.detalhe.competencia' | translate }}</th>
          <th>{{ 'indicacoes.detalhe.valor' | translate }}</th>
          <th>{{ 'indicacoes.detalhe.porcentagem' | translate }}</th>
          <th>{{ 'indicacoes.detalhe.repasse' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-comissao>
        <tr [class.linha-cancelada]="isComissaoCancelada(comissao)">
          <td>{{ formatarCompetencia(comissao.competencia) }}</td>
          <td>{{ comissao.valorComissao | guaraniFormat }}</td>
          <td>{{ comissao.porcentagemComissao }}%</td>
          <td>
            <p-tag
              [value]="labelStatusRepasse(comissao.statusRepasse)"
              [severity]="severityStatusRepasse(comissao.statusRepasse)">
            </p-tag>
            <div class="repassado-em" *ngIf="comissao.statusRepasse === 'PAGA' && comissao.repassadoEm">
              {{ 'indicacoes.detalhe.repassado_em' | translate: { data: formatarData(comissao.repassadoEm) } }}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'indicacoes.detalhe.fechar' | translate"
      class="p-button-secondary"
      (click)="fecharDetalhe()">
    </button>
  </ng-template>
</p-dialog>

<!-- =================================================================== -->
<!-- Dialog: Novo cupom de desconto (apenas master)                      -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="cupomDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign dialog-novo-cupom"
  [style]="{ width: '36rem' }">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-ticket" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'indicacoes.novo_cupom.titulo' | translate }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <div class="form-grid-cupom">
      <!-- Codigo -->
      <div class="form-field full">
        <label class="form-label">
          {{ 'indicacoes.novo_cupom.codigo' | translate }} <span class="required">*</span>
        </label>
        <input type="text" pInputText
          class="w-full"
          [(ngModel)]="cupomForm.codigo"
          [class.error-field]="cupomSubmetido && !cupomForm.codigo.trim()"
          [placeholder]="'indicacoes.novo_cupom.codigo_placeholder' | translate"
          autocomplete="off" />
      </div>

      <!-- Desconto %: nao existe no cupom especial (o valor negociado ja e o final) -->
      <div class="form-field half" *ngIf="!cupomForm.especial">
        <label class="form-label">
          {{ 'indicacoes.cupom_detalhe.desconto' | translate }} (%) <span class="required">*</span>
        </label>
        <p-inputNumber [(ngModel)]="cupomForm.porcentagemDesconto"
          [min]="0" [max]="100" suffix="%"
          [class.error-field]="cupomSubmetido && cupomForm.porcentagemDesconto == null"
          styleClass="w-full" inputStyleClass="w-full">
        </p-inputNumber>
      </div>

      <!-- Comissao % -->
      <div class="form-field half">
        <label class="form-label">
          {{ 'indicacoes.cupom_detalhe.comissao' | translate }} (%) <span class="required">*</span>
        </label>
        <p-inputNumber [(ngModel)]="cupomForm.porcentagemComissao"
          [min]="0" [max]="100" suffix="%"
          [class.error-field]="cupomSubmetido && cupomForm.porcentagemComissao == null"
          styleClass="w-full" inputStyleClass="w-full">
        </p-inputNumber>
      </div>

      <!-- Tipo de repasse -->
      <div class="form-field half">
        <label class="form-label">{{ 'indicacoes.cupom_detalhe.tipo_periodo' | translate }}</label>
        <p-dropdown [options]="tipoPeriodoOptions" optionLabel="label" optionValue="value"
          [(ngModel)]="cupomForm.tipoPeriodo" appendTo="body" styleClass="w-full">
        </p-dropdown>
      </div>

      <!-- Validade -->
      <div class="form-field half">
        <label class="form-label">{{ 'indicacoes.novo_cupom.validade' | translate }}</label>
        <p-calendar [(ngModel)]="cupomForm.dataValidade"
          dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"
          [placeholder]="'indicacoes.novo_cupom.validade_placeholder' | translate"
          styleClass="w-full" inputStyleClass="w-full">
        </p-calendar>
      </div>

      <!-- Empresa (opcional) -->
      <div class="form-field full">
        <label class="form-label">{{ 'indicacoes.novo_cupom.empresa' | translate }}</label>
        <p-autoComplete [(ngModel)]="cupomForm.empresa"
          [suggestions]="empresasSugestoes"
          (completeMethod)="buscarEmpresas($event)"
          field="nome" [minLength]="1" [delay]="300" [forceSelection]="true"
          inputStyleClass="w-full" appendTo="body" styleClass="w-full master-busca-empresa"
          [placeholder]="'indicacoes.novo_cupom.empresa_placeholder' | translate">
          <ng-template let-empresa pTemplate="item">
            <div class="master-empresa-item">
              <span class="master-empresa-nome">{{ empresa.nome || empresa.email || ('#' + empresa.id) }}</span>
              <span class="master-empresa-email"
                *ngIf="empresa.nome && empresa.email && empresa.email !== empresa.nome">{{ empresa.email }}</span>
            </div>
          </ng-template>
        </p-autoComplete>
        <small class="form-ajuda">{{ 'indicacoes.novo_cupom.empresa_ajuda' | translate }}</small>
      </div>

      <!-- Cupom especial de plano: em vez de descontar, o cupom DEFINE a contratacao -->
      <div class="form-field full">
        <div class="cupom-especial-toggle">
          <p-inputSwitch [(ngModel)]="cupomForm.especial"
            inputId="cupomEspecial"></p-inputSwitch>
          <label for="cupomEspecial" class="form-label">
            {{ 'indicacoes.novo_cupom.especial_toggle' | translate }}
          </label>
        </div>
        <small class="form-ajuda">{{ 'indicacoes.novo_cupom.especial_ajuda' | translate }}</small>
      </div>

      <ng-container *ngIf="cupomForm.especial">
        <!-- Categoria do plano -->
        <div class="form-field half">
          <label class="form-label">
            {{ 'indicacoes.novo_cupom.categoria' | translate }} <span class="required">*</span>
          </label>
          <p-dropdown [options]="categoriaPlanoOptions" optionLabel="label" optionValue="value"
            [(ngModel)]="cupomForm.categoriaPlano" appendTo="body" styleClass="w-full"
            [class.error-field]="cupomSubmetido && cupomForm.categoriaPlano == null"
            [placeholder]="'indicacoes.novo_cupom.categoria_placeholder' | translate">
          </p-dropdown>
        </div>

        <!-- Periodo em dias -->
        <div class="form-field half">
          <label class="form-label">
            {{ 'indicacoes.novo_cupom.periodo_dias' | translate }} <span class="required">*</span>
          </label>
          <p-inputNumber [(ngModel)]="cupomForm.periodoDias"
            [min]="1" [useGrouping]="false"
            [class.error-field]="cupomSubmetido && cupomForm.periodoDias == null"
            styleClass="w-full" inputStyleClass="w-full">
          </p-inputNumber>
        </div>

        <!-- Valor do plano -->
        <div class="form-field half">
          <label class="form-label">
            {{ 'indicacoes.novo_cupom.valor_plano' | translate }} <span class="required">*</span>
          </label>
          <p-inputNumber [(ngModel)]="cupomForm.valorPlano"
            [min]="0" [maxFractionDigits]="0"
            [class.error-field]="cupomSubmetido && cupomForm.valorPlano == null"
            styleClass="w-full" inputStyleClass="w-full">
          </p-inputNumber>
        </div>

        <!-- Limite de vendas por mes -->
        <div class="form-field half">
          <label class="form-label">
            {{ 'indicacoes.novo_cupom.limite_gasto' | translate }} <span class="required">*</span>
          </label>
          <p-inputNumber [(ngModel)]="cupomForm.limiteDeGasto"
            [min]="0" [maxFractionDigits]="0"
            [class.error-field]="cupomSubmetido && cupomForm.limiteDeGasto == null"
            styleClass="w-full" inputStyleClass="w-full">
          </p-inputNumber>
        </div>
      </ng-container>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'indicacoes.novo_cupom.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="salvandoCupom"
      (click)="fecharNovoCupom()">
    </button>
    <button pButton
      [label]="'indicacoes.novo_cupom.salvar' | translate"
      icon="pi pi-check"
      class="btn-primary"
      style="gap: 0.35rem"
      [disabled]="salvandoCupom"
      [loading]="salvandoCupom"
      (click)="salvarCupom()">
    </button>
  </ng-template>
</p-dialog>


<!-- =================================================================== -->
<!-- Dialog: Percentual padrao dos cupons automaticos (apenas master)     -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="padraoDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign dialog-novo-cupom"
  [style]="{ width: '34rem' }">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-percentage" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'indicacoes.percentual_padrao.titulo' | translate }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <!-- Carregando os percentuais vigentes -->
    <div *ngIf="carregandoPadrao" class="estado-inline">
      <i class="pi pi-spinner pi-spin"></i>
      <span>{{ 'indicacoes.percentual_padrao.carregando' | translate }}</span>
    </div>

    <div class="form-grid-cupom" *ngIf="!carregandoPadrao">
      <div class="form-field full">
        <small class="form-ajuda">{{ 'indicacoes.percentual_padrao.explicacao' | translate }}</small>
      </div>

      <!-- Desconto % -->
      <div class="form-field half">
        <label class="form-label">
          {{ 'indicacoes.cupom_detalhe.desconto' | translate }} (%) <span class="required">*</span>
        </label>
        <p-inputNumber [(ngModel)]="padraoForm.porcentagemDesconto"
          [min]="0" [max]="100" suffix="%"
          [class.error-field]="padraoSubmetido && padraoForm.porcentagemDesconto == null"
          styleClass="w-full" inputStyleClass="w-full">
        </p-inputNumber>
      </div>

      <!-- Comissao % -->
      <div class="form-field half">
        <label class="form-label">
          {{ 'indicacoes.cupom_detalhe.comissao' | translate }} (%) <span class="required">*</span>
        </label>
        <p-inputNumber [(ngModel)]="padraoForm.porcentagemComissao"
          [min]="0" [max]="100" suffix="%"
          [class.error-field]="padraoSubmetido && padraoForm.porcentagemComissao == null"
          styleClass="w-full" inputStyleClass="w-full">
        </p-inputNumber>
      </div>

      <!-- Aviso da renomeacao: so aparece quando o desconto realmente muda -->
      <div class="form-field full" *ngIf="descontoPadraoAlterado()">
        <small class="form-ajuda">
          <i class="pi pi-info-circle" aria-hidden="true"></i>
          {{ 'indicacoes.percentual_padrao.aviso_renomeio' | translate:
             { antes: percentualPadraoVigenteFormatado(), depois: percentualPadraoNovoFormatado() } }}
        </small>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'indicacoes.novo_cupom.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="salvandoPadrao"
      (click)="fecharPercentualPadrao()">
    </button>
    <button pButton
      [label]="'indicacoes.novo_cupom.salvar' | translate"
      icon="pi pi-check"
      class="btn-primary"
      style="gap: 0.35rem"
      [disabled]="salvandoPadrao || carregandoPadrao"
      [loading]="salvandoPadrao"
      (click)="salvarPercentualPadrao()">
    </button>
  </ng-template>
</p-dialog>


<!-- =================================================================== -->
<!-- Dialog: Confirmar revogacao dos cupons selecionados (apenas master)  -->
<!-- =================================================================== -->
<p-dialog
  [(visible)]="revogarDialogVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign dialog-footer-end"
  [style]="{ width: '32rem' }"
  [breakpoints]="{ '640px': '95vw' }">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-ban" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'indicacoes.revogar_cupons.titulo' | translate }}</h2>
        <p class="dialog-wave-subtitle">
          {{ 'indicacoes.revogar_cupons.selecionados' | translate: { count: cuponsSelecionados.length } }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ 'indicacoes.revogar_cupons.confirmacao' | translate: { count: cuponsSelecionados.length } }}</p>
    <small class="form-ajuda">{{ 'indicacoes.revogar_cupons.explicacao' | translate }}</small>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
      [label]="'indicacoes.novo_cupom.cancelar' | translate"
      class="p-button-secondary"
      [disabled]="revogandoCupons"
      (click)="fecharRevogarCupons()">
    </button>
    <button pButton
      [label]="'indicacoes.revogar_cupons.confirmar' | translate"
      icon="pi pi-ban"
      class="p-button-danger"
      style="gap: 0.35rem"
      [disabled]="revogandoCupons"
      [loading]="revogandoCupons"
      (click)="confirmarRevogarCupons()">
    </button>
  </ng-template>
</p-dialog>

<p-toast />
